import { render, staticRenderFns } from "./dialogFreeItem.vue?vue&type=template&id=6e145a3c&scoped=true&"
import script from "./dialogFreeItem.vue?vue&type=script&lang=js&"
export * from "./dialogFreeItem.vue?vue&type=script&lang=js&"
import style0 from "./dialogFreeItem.vue?vue&type=style&index=0&id=6e145a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e145a3c",
  null
  
)

export default component.exports